<template>
    <div class="video-card-featured-wrapper">
      <div class="row">
        <div class="col-12 col-md-8 pt-md-0 pl-md-3 mt-n3 mt-md-0">
          <div v-if="isLoading">
              <div><video-loading-skeleton /></div>
          </div>
          <div v-else class="video-player-wrapper">
            <iframe 
                :src=this.videoPreviewUrl 
                scrolling="no" 
                allowfullscreen 
                :title="this.featuredVideo.Title">
            </iframe>
          </div>
        </div>
        <div class="col-12 col-md-4 pt-md-0 pl-md-3 mt-md-0">
          <div class="video-card-body px-0 pt-3 pt-md-0">
            <video-card-details class="pb-1 pb-md-0" :date="this.featuredVideo.StartDate" />
            <div class="pt-1" @click="navigateToVideoPost()">
              <h3 class="card-title">{{ this.featuredVideo.Title }}</h3>
            </div>
            <div class="card-description" v-html="`${this.truncateString(this.featuredVideo.Summary, 250)}`"></div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  
  import api from "@/api";
  import VideoCardDetails from "./VideoCardDetails";
  import VideoLoadingSkeleton from "./VideoLoadingSkeleton";
  import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";
  
  export default {
    name: "video-card-featured",
    props: ["featuredVideo"],
    mixins: [HomebaseMixpanelMixin],
    components: {
      VideoCardDetails,
      VideoLoadingSkeleton
    },
    data() {
      return {
        isLoading: false,
        videoPreviewUrl: null
      }
    },
    created() {
      this.initializeVideoCardFeatured();
    },
    methods: {
      async initializeVideoCardFeatured() {
        try {
          this.isLoading = true;
          const videoPreviewResponse = await this.getVideoCampaignURL(this.featuredVideo.id);
          this.videoPreviewUrl = videoPreviewResponse.getUrl;
          this.isLoading = false;
        } catch (e) {
          this.handleVideoLoadError();
        }
      },

      async getVideoCampaignURL(itemId) {
        return await api.getVideoCampaignPreview(itemId);
      },

      navigateToVideoPost() {
        this.trackVideoCampaignPostClick(`${this.featuredVideo.Title} - ${this.featuredVideo.URL.Url}`);
        window.open(this.featuredVideo.URL.Url, Vue.prototype.$getAoneLinkTarget(this.featuredVideo.URL.Url));
      },

      truncateString(str, maxLength) {
        if (str.length > maxLength) {
          return str.slice(0, maxLength - 3) + '...';
        }
        return str;
      },
  
      handleVideoLoadError() {
        this.$emit("isError");
      }
    }
  };
  </script>
  
  <style scoped>
  .video-card-featured-wrapper {
    color: #000 !important;
  }
  .video-card-featured-wrapper:hover {
    text-decoration: none !important;
  }
  .video-player-wrapper {
    height: auto;
    width: 100%
  }

  .video-player-wrapper iframe {
    width: 100%;
    border: none;
  }

  .card-title:hover {
    cursor: pointer;
  }

  .card-img {
    height: 200px;
    border-radius: 5px;
    object-fit: cover;
    object-position: 50% 35%;
  }
  
  .line-clamp {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  @media (min-width: 576px) {
    .video-player-wrapper iframe { 
      min-height: 315px;
    }
  }

  @media (min-width: 1200px) {
    .video-card-body {
      padding-top: 0px;
      margin-top: -4px;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/homebase/campaigns/VideoCardFeatured.vue